var map = {
	"./Objectivity-Bold.otf": 371,
	"./Objectivity-Bold.woff": 372,
	"./Objectivity-Bold.woff2": 373,
	"./Objectivity-Medium.otf": 374,
	"./Objectivity-Medium.woff": 375,
	"./Objectivity-Medium.woff2": 376,
	"./Roboto-Bold.ttf": 377,
	"./Roboto-Regular.ttf": 378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 370;